require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./mail-coach-chrome-extension.json") })
        }
      }, "path---mail-coach-chrome-extension");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---mail-coach-chrome-extension!./.cache/json/mail-coach-chrome-extension.json
// module id = 281
// module chunks = 231608221292675